import gql from 'graphql-tag';
const MATH_MASTER_ACTIVITY_FRAGMENT = gql `
  fragment MathMasterActivityFragment on MathMasterActivity {
    rounds {
      roundIndex
      operation
      numbers
      results {
        text
        number
        isCorrect
      }
      steps {
        stepIndex
        answer
      }
    }
  }
`;
export default MATH_MASTER_ACTIVITY_FRAGMENT;
